import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import { getEditRequest } from 'state/scheduledRuns/selectors';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';

export function createScheduledRunEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) => {
    const { createRunRequest } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_CREATION_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) => {
        const request = getEditRequest(state, id);
        if (!request) {
          return EMPTY;
        }
        return createRunRequest(request, getWorkspaceType(state, id)).pipe(
          map(res => scheduledRunActions.scheduledRunCreationSucceeded(id, res)),
          catchError((err: HttpError) => {
            return of(scheduledRunActions.scheduledRunCreationFailed(id, toTypedError('Pricing Runs DIY', err)));
          }),
        );
      }),
    );
  };
}
